var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import Checkbox from "core/Checkbox";
import Link from "core/Link";
import styles from "./AiOptOutSection.module.css";
import { IMAGE_GENERATION_OPT_OUT_STATUS_QUERY, CHANGE_AI_OPT_OUT_STATUS_MUTATION, } from "./queries";
var AiOptOutSection = function () {
    var _a = useState(false), isOptedOut = _a[0], setIsOptedOut = _a[1];
    var _b = useState(false), isRateLimited = _b[0], setIsRateLimited = _b[1];
    var _c = useQuery(IMAGE_GENERATION_OPT_OUT_STATUS_QUERY, {
        onCompleted: function (data) {
            var _a = data.imageGenerationOptOutStatus, optedOutOfGeneratedImageUsage = _a.optedOutOfGeneratedImageUsage, rateLimitedFromQuery = _a.isRateLimited;
            setIsOptedOut(optedOutOfGeneratedImageUsage);
            setIsRateLimited(rateLimitedFromQuery);
        },
    }), loading = _c.loading, error = _c.error;
    var changeAiOptOutStatus = useMutation(CHANGE_AI_OPT_OUT_STATUS_MUTATION)[0];
    if (loading || error)
        return null;
    var handleCheckboxClick = function (newCheckedValue) { return __awaiter(void 0, void 0, void 0, function () {
        var newOptOut, result, _a, ok, optOutValue, mutationError, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    newOptOut = !newCheckedValue;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, changeAiOptOutStatus({
                            variables: { optOut: newOptOut },
                        })];
                case 2:
                    result = _b.sent();
                    _a = result.data.changeAiOptOutStatus, ok = _a.ok, optOutValue = _a.optOutValue, mutationError = _a.error;
                    if (ok) {
                        setIsOptedOut(optOutValue);
                    }
                    else if (mutationError === null || mutationError === void 0 ? void 0 : mutationError.startsWith("Please wait")) {
                        setIsRateLimited(true);
                    }
                    else {
                        console.error("AI opt-out status change failed:", mutationError);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    console.error("AI opt-out mutation error:", e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: styles.container, children: [_jsx("h3", { className: styles.headline, children: "Your Opt-In Preference for Noun Studio" }), _jsxs("p", { className: styles.blurb, children: ["Noun Studio is a specialized icon editor and generator that creates visually consistent results, while compensating human designers. When an edited or generated icon is downloaded in Noun Studio, the creator of the original reference icon receives a share of the net revenue as royalties. Icons created with Noun Studio cannot be submitted to Noun Project\u2019s icon collection.", " ", _jsx(Link, { size: "sm", target: "_blank", href: "https://help.thenounproject.com/hc/en-us/sections/54426587146523-Noun-Studio", disableVisitedStyle: true, children: "Learn More" })] }), _jsx(Checkbox, { className: styles.checkbox, isChecked: !isOptedOut, isDisabled: isRateLimited, onClick: handleCheckboxClick, label: "Yes, make my icons available for use in Noun Studio and eligible to earn royalties from it." }), _jsx("p", { className: styles.optOutHelperText, children: "You may update this preference up to twice every 7 days. Opt-in changes may take up to 72 hours to take effect on the site." }), isRateLimited && (_jsx("div", { className: "".concat(styles.message, " ").concat(styles.lockedMessage), children: "Your preferences are temporarily locked because you\u2019ve made the maximum number of changes allowed in 7 days." })), isOptedOut && (_jsxs("div", { className: "".concat(styles.message, " ").concat(styles.optedOutMessage), children: ["You have opted out of Noun Studio. Your icons will not be available for use with the tool, and you will not be able to earn royalties from Noun Studio.", " "] }))] }));
};
export default AiOptOutSection;
